import styled from "styled-components";
import { Link } from "react-router-dom";
export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: auto;
  font-family: 'Montserrat Medium', 'Open Sans', Helvetica, Arial, sans-serif;
  @media(max-width:767px){
    display:block;
    overflow-x:scroll;
  }
`;

export const Column = styled.div`
  width: 33.33%;
  height: 50px;
  padding-left: 20px;
  display: grid;
  grid-template-columns: 50% 50%;
  @media(max-width:767px){
    width: 100%;
  }
`;
export const Bold = styled.div`
  color: #58595B;
  font-family: 'Montserrat Medium', 'Open Sans', Helvetica, Arial, sans-serif;
  font-size:16px;
  @media (max-width:666px){
    font-size:16px;
  }
`;
export const Value = styled.div`
  font-size: 16px;
  color: #58595B;
  font-weight: 600;
  font-family: 'Montserrat Medium', 'Open Sans', Helvetica, Arial, sans-serif;
  @media (max-width:666px){
    font-size:10px;
  }
`;
export const GridDashBoard = styled.div`
  display: block;
  grid-template-columns:100%;
  background-color:#f9f9f9;
  min-height:100vh;
  padding-right: 15px;
  padding-left: 15px;
  padding-Bottom: 50px;
  @media (max-width:990px){
   grid-template-columns: 100%;
   padding: 20px 15px 50px;
  }
`;
export const CustomLink = styled(Link)`
margin-top: 10px !important;
width: auto;
padding:3px 27px;
border-radius: 20px;
font-weight:600;
font-size:13px;
text-decoration: none;
box-shadow:5px 5px 10px 1px #C8C8C8;
float: right;
background-image: linear-gradient(315deg, #4487d1 0%, #009ffd 74%);
color:white;
font-family: Montserrat, 'Open Sans', Helvetica, Arial, sans-serif;
&:hover {
  background-image: linear-gradient(315deg, #4487d1 0%, #009ffd 74%) !important;
  color:white !important
}


`;

export const CustomLinkBut = styled(Link)`
  margin-top: 10px !important;
  width: auto;
  padding:3px 27px;
  border-radius: 20px;
  font-weight:600;
  font-size:13px;
  text-decoration: none;
  box-shadow:5px 5px 10px 1px #C8C8C8;
  float: right;
  background-image: linear-gradient(315deg, #4487d1 0%, #009ffd 74%);
  color:white;
  font-family: Montserrat, 'Open Sans', Helvetica, Arial, sans-serif;
  &:hover {
    background-image: linear-gradient(315deg, #4487d1 0%, #009ffd 74%) !important;
    color:white !important;
    transform: scale(1.1) !important;
  }


`;

export const ADImage = styled.img`
width:786px;
height:90px;
@media (max-width:1066px){
  width:90%;
}
`

export const ADHImage = styled.img`
width:160px;
height:600px;
@media (max-width:966px){
  width:140px;
}
@media (max-width:766px){
  width:120px;
}
@media (max-width:640px){
  width:105px;
}
`
export const CustomBTNDIV = styled.div`
margin-top:403px;
@media (max-width:990px){
  margin-top:65vh;
}
@media (max-width:900px){
  margin-top:75vh;
}
@media (max-width:795px){
  margin-top:85vh;
}

@media (max-width:640px){
  margin-top:85vh;
}
`